import { render, staticRenderFns } from "./catering.vue?vue&type=template&id=42e13160&scoped=true&"
import script from "./catering.vue?vue&type=script&lang=js&"
export * from "./catering.vue?vue&type=script&lang=js&"
import style0 from "./catering.vue?vue&type=style&index=0&id=42e13160&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e13160",
  null
  
)

export default component.exports